// ══════════════════════════════════════════════════════════════════════════
//  EL DICCIONARIO DEL DINERO — una sola verdad de cómo se llama cada peso
//
//  El mismo cobro se llamaba distinto en cada pantalla: `EN ESPERA DE FACTURA`
//  era "En espera de factura" en la bitácora, "Por facturar" en el buscador y
//  en la Mesa, y "Pendiente Factura" en el badge; `EN DISPUTA` salía en teal en
//  un lado y en rojo en otro. Nueve mapas para el mismo dato. Si el mismo peso
//  se llama distinto en cuatro pantallas no hay lenguaje común que valga.
//
//  `corta` es para donde el ancho manda (el badge de una fila, la etiqueta del
//  diagrama); `larga` para donde hay sitio y para lo que se lee en voz alta (la
//  revelación al señalar, un correo). NO son dos vocabularios: son dos formas
//  del MISMO nombre, declaradas juntas y en un solo lugar.
//
//  El PDF de la estimación NO lee de aquí a propósito: sus etiquetas son
//  editables por el dueño en Configuraciones > Formato de reportes
//  (reportTemplates.js, sección 'estatus'), y un documento que ya salió firmado
//  con unas palabras no puede cambiarlas porque la pantalla cambió.
// ══════════════════════════════════════════════════════════════════════════
export const ESTATUS_COBRO = {
  'ESTIMACION ENVIADA':     { corta: 'Enviada',       larga: 'Estimación enviada al cliente', color: 'orange' },
  'EN ESPERA DE FACTURA':   { corta: 'Por facturar',  larga: 'Autorizada, por facturar',      color: 'purple' },
  'FACTURA ENVIADA':        { corta: 'Facturada',     larga: 'Facturada, por cobrar',         color: 'blue' },
  'PARCIALMENTE FACTURADA': { corta: 'Parcial. fact.', larga: 'Facturada en parte',           color: 'purple' },
  'PARCIALMENTE PAGADA':    { corta: 'Pago parcial',  larga: 'Pagada en parte',               color: 'teal' },
  'FACTURA PAGADA':         { corta: 'Pagada',        larga: 'Pagada',                        color: 'green' },
  'EN DISPUTA':             { corta: 'En disputa',    larga: 'En disputa con el cliente',     color: 'critical' },
  'SIN ACTIVIDAD':          { corta: 'Sin actividad', larga: 'Período sin actividad',         color: 'gray' },
  'CANCELADA':              { corta: 'Cancelada',     larga: 'Cancelada',                     color: 'gray' },
};

// Un estatus fuera del catálogo se muestra CRUDO y en gris, nunca se traduce a
// una etiqueta parecida: la base no valida `estatus_cobro`, así que un valor
// desconocido es un dato que hay que ver, no que disimular.
export const etiquetaCobro = (estatus, forma = 'corta') =>
  ESTATUS_COBRO[estatus]?.[forma] || estatus || '';
export const colorCobro = (estatus) => ESTATUS_COBRO[estatus]?.color || 'gray';

// Vive en un archivo SIN dependencias, y no dentro de facturacion.logic.js,
// porque lo consume `components/ui/estatus.js` (el barril del sistema de
// diseño): con el diccionario dentro del motor, el motor entero de facturas,
// pagos, saldos y vencimientos viajaba al chunk de ENTRADA — el que descarga
// todo visitante, incluidas las páginas públicas del QR (/verificar, /firmante,
// /acuse, /reportes) que abren teléfonos desconocidos desde un papel impreso.
// `facturacion.logic.js` lo re-exporta, así que nadie cambia de dónde importa.
